import React, { useEffect } from 'react'

export default function GaugeWidget(props) {
    useEffect(() => {

    }, []);

    return <div></div>
}
